
import { copyText } from '~/util/brokerage-hr'

export default {
    data () {
        return { loading: false, items: [], links: {} }
    },
    mounted () {
        this.load()
    },
    methods: {
        async load () {
            this.loading = true
            const res = await this.$try('getFeedbackTestAccounts')
            this.loading = false
            if (!res || res.error) return
            this.items = res.items
        },
        async copyLink (item) {
            const res = await this.$try('makeFeedbackTestLink', { client_id: item.client_id })
            if (!res || res.error) return
            // Shown as well as copied: some browsers refuse a copy after an await.
            this.$set(this.links, item.client_id, res.url)
            await copyText(this.$store, res.url)
        },
    },
}
